const STORAGE_PREFIX = 'suggestedPolicyPrefill:';

export function generatePolicyPrefillHandle() {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getPolicyPrefillStorageKey(handle) {
  return `${STORAGE_PREFIX}${handle}`;
}

export function storePolicyPrefill(handle, payload) {
  window.localStorage.setItem(
    getPolicyPrefillStorageKey(handle),
    JSON.stringify(payload)
  );
}

export function stagePolicyPrefill(payload) {
  const handle = generatePolicyPrefillHandle();
  storePolicyPrefill(handle, payload);
  return handle;
}

export function removePolicyPrefill(handle) {
  if (!handle) return;
  try {
    window.localStorage.removeItem(getPolicyPrefillStorageKey(handle));
  } catch (_) {
    // Storage cleanup is best effort.
  }
}

function readPolicyPrefill(handle) {
  if (!handle) return null;
  try {
    const raw = window.localStorage.getItem(
      getPolicyPrefillStorageKey(handle)
    );
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

/**
 * Consumes a one-time prefill payload and removes its route handle.
 */
export function consumePolicyPrefillFromRoute(
  router,
  route,
  accepts = () => true
) {
  const handle = route && route.query ? route.query.prefill : null;
  if (!handle) return null;

  const payload = readPolicyPrefill(handle);
  const accepted = payload && accepts(payload) ? payload : null;
  removePolicyPrefill(handle);

  const query = { ...route.query };
  delete query.prefill;
  router.replace({ path: route.path, query }).catch(() => {});

  return accepted;
}
